import { render, staticRenderFns } from "./widget-projects.vue?vue&type=template&id=2f028d44"
import script from "./widget-projects.vue?vue&type=script&lang=js"
export * from "./widget-projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports